import i18n from "i18n";

export const geofenceMessages = {
  update: i18n.t('notifications.geofence.update')
}
